import { render, staticRenderFns } from "./NewFieldDialog.vue?vue&type=template&id=5e3d9470&scoped=true&"
import script from "./NewFieldDialog.vue?vue&type=script&lang=js&"
export * from "./NewFieldDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewFieldDialog.vue?vue&type=style&index=0&id=5e3d9470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d9470",
  null
  
)

export default component.exports